
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...spaInsLifeQuotesFR]",
      function () {
        return require("private-next-pages/[...spaInsLifeQuotesFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...spaInsLifeQuotesFR]"])
      });
    }
  